import Axios from "../util/axiosInstance";


export const RemoveProjectFromBookmark = (jobId, instrId) => {
    if (instrId === "all") {
        return Axios.delete(`/api/TalentJobCenter/DeleteSavedJob?projectId=${jobId}`)
    } else {
        return Axios.delete(`/api/TalentJobCenter/DeleteSavedJob?projectId=${jobId}&instrId=${instrId}`)
    }
}